
const config = {  }
export { config as default }